import React, { useEffect } from 'react';
import ColorButton from './ColorButton';
import GenericButton from './GenericButton';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedColorOption } from '../app/mainSlice';
import { isMobile } from 'react-device-detect';

/**
 * @param props.colorOptions
 * @param props.handleAddColor
 * @param props.isInsuranceLoading
 * @param props.config
 */
const ColorSelector = props => {
    const dispatch = useDispatch();
    const labels = useSelector(state => state.main.labels);
    const selectedColorOption = useSelector(state => state.main.selectedColorOption);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);

    const handleSetColorOption = colorOption => {
        dispatch(setSelectedColorOption(colorOption));
    };

    useEffect(() => {
        let firstColorOption =
            props.colorOptions && props.colorOptions.length > 0 ? props.colorOptions[0] : null;

        if (selectedColorOption == null && firstColorOption !== null) {
            handleSetColorOption(firstColorOption);
        } else if (selectedColorOption !== null) {
            handleSetColorOption(selectedColorOption);
        }
    }, []);

    const renderColors = () => {
        let colorOptions = props.colorOptions || [];
        let firstColorOption = props.colorOptions.length > 0 ? props.colorOptions[0] : null;

        return colorOptions.map(colorOption => {
            let isSelected = false;

            if (
                (selectedColorOption == null &&
                    firstColorOption !== null &&
                    colorOption.id == firstColorOption.id) ||
                (selectedColorOption !== null && colorOption.id == selectedColorOption.id)
            ) {
                isSelected = true;
            }

            return (
                <ColorButton
                    config={props.config}
                    key={colorOption.id}
                    title={colorOption.title}
                    isSelected={isSelected}
                    className={
                        !isMobile && !colorOption.imageFileName2 ? ' circle-color-button' : ''
                    }
                    imageFileName={
                        isMobile || !colorOption.imageFileName2
                            ? colorOption.imageFileName1
                            : colorOption.imageFileName2
                    }
                    colorFileName={null}
                    handleClick={() => {
                        handleSetColorOption(colorOption);
                    }}
                    imageAlt={colorOption.title}
                />
            );
        });
    };

    return isMobile ? (
        <div id="color-mobile" className="color-selector-mobile">
            <div className="color-select-title">{labels.selectColor}</div>
            <div className="image-color">{renderColors()}</div>
        </div>
    ) : (
        <div id="color" className="color-selector-desktop">
            <div
                className={
                    'color-select-title' + (isLearnMoreModalOpen ? ' color-select-title-white' : '')
                }
            >
                {labels.selectColor}
            </div>
            <div className="image-color">{renderColors()}</div>
            {!isLearnMoreModalOpen &&
            props.group !== 'colorCategory' &&
            props.colorOptions &&
            props.colorOptions.length > 1 ? (
                <div className="color-button-add">
                    <GenericButton
                        className="border-button-add"
                        handleClick={props.handleAddColor}
                        disabled={props.isInsuranceLoading}
                    >
                        {labels.add}
                    </GenericButton>
                </div>
            ) : null}
        </div>
    );
};

export default ColorSelector;
